import { SET_MAX_DURATION_SECONDS } from '@/services/sets.api';

export const SET_DANGER_THRESHOLD_SECONDS = 9900;

export const formatSetDuration = (seconds: number): string => {
  const safe = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  return `${hours}:${String(minutes).padStart(2, '0')}`;
};

export const formatTrackDuration = (seconds?: number): string => {
  if (!seconds || seconds <= 0) return '—';
  const safe = Math.floor(seconds);
  const minutes = Math.floor(safe / 60);
  const secs = safe % 60;
  return `${minutes}:${String(secs).padStart(2, '0')}`;
};

export const setDurationRatio = (seconds: number): number =>
  Math.min(1, Math.max(0, seconds / SET_MAX_DURATION_SECONDS));

export const isSetDurationDanger = (seconds: number): boolean =>
  seconds >= SET_DANGER_THRESHOLD_SECONDS;

export const SET_MAX_DURATION_LABEL = formatSetDuration(SET_MAX_DURATION_SECONDS);
